import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "./styles/LayoutPatch.css"; // ✅ IMPORT DO PATCH (SEMPRE POR ÚLTIMO)

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
